'use strict';

var base = require('core/product/quickView');
var productUtils = require('../utilities/productUtils')

base.updateWhyWeLoveIt = productUtils.updateWhyWeLoveIt;

module.exports = base;
